import React from 'react';
import { useStateSelector } from '../../../store/selectors';
import './QuestionnaireFormPopup.scss';
import { ModalBody, ModalHeader } from 'reactstrap';
import QuestionnaireForm from '../QuestionnaireForm/QuestionnaireForm';
import { DataForm } from '../../../models/DataRequestHub/DataForm';
import { DataRequestProject } from '../../../models/DataRequestHub/DataRequestProject';
import DataFormQuestion, {
    isQuestionVisibleByLogic,
} from '../../../models/DataRequestHub/DataFormQuestion';
import QuestionSeenStatus from '../../../models/DataRequestHub/QuestionSeenStatus';
import Rodal from '../../../components/Rodal/Rodal';

interface QuestionnaireFormPopupProps {
    header: string;
    isAdminView: boolean;
    form: DataForm;
    project: DataRequestProject;
    isReadonlyMode: boolean;
    onlyShowQuestionColumns: boolean;
    updateProjectsData: (isInitialFetch?: boolean) => void;
    questionsSeenStatus: QuestionSeenStatus[];
    triggerNext?: () => void;
    triggerBack?: () => void;
}
export const QuestionnaireFormPopup = (props: QuestionnaireFormPopupProps) => {
    const currentUser = useStateSelector((s) => s.currentUser);
    const handleBackStep = () => {
        if (props.triggerBack) {
            props.triggerBack();
        }
    };

    const isAccessRightsColumnVisible = () => {
        const isOwnerAccess = props.project.userId === currentUser?.user?.id;
        const doAffiliatedMembersExist =
            props.project.affiliatedMembers?.length > 0;
        return (isOwnerAccess || props.isAdminView) && doAffiliatedMembersExist;
    };

    const filterCurrentQuestionsByModule = () => {
        const visibleQuestions = filterQuesitonsByLogic(props.form?.questions);
        const currentSubQuestions = visibleQuestions.filter(
            (subQuestion) =>
                subQuestion.isSubQuestion &&
                visibleQuestions.some(
                    (question) => question.id === subQuestion.originQuestionId
                )
        );

        return [...visibleQuestions, ...currentSubQuestions];
    };

    const filterQuesitonsByLogic = (data: DataFormQuestion[]) => {
        const result = data.filter((x) => isQuestionVisibleByLogic(data, x));
        return result;
    };

    return (
        <div className="questionnaire-form-popup">
            {props.form && props.project ? (
                <Rodal
                    visible={true}
                    onClose={handleBackStep}
                    className="table-form-popup"
                    width={500}
                    animation="fade"
                    closeMaskOnClick={false}
                    centered>
                    <ModalHeader>{props.header}</ModalHeader>
                    <ModalBody>
                        <QuestionnaireForm
                            key={'questionnaire-view-form'}
                            isAdminView={props.isAdminView}
                            isComplete={props.form.isComplete}
                            projectId={props.project.id}
                            projectVariables={props.project.variables}
                            questionnaireFormId={props.form?.id}
                            visibleQuestionnaireQuestions={filterCurrentQuestionsByModule()}
                            updateProjectsData={props.updateProjectsData}
                            project={props.project}
                            questionsSeenStatus={props.questionsSeenStatus}
                            isAccessRightColumnVisible={isAccessRightsColumnVisible()}
                            onlyShowQuestionColumns={
                                props.onlyShowQuestionColumns
                            }
                            isReadonlyMode={props.isReadonlyMode}
                            isBuiltIn={false}
                        />
                    </ModalBody>
                </Rodal>
            ) : (
                []
            )}
        </div>
    );
};
